export default "__VITE_IMAGE_ASSET__f6b75ac2__";